import React from 'react'
import './AboutUs.scss'

const aboutUs = () => {
  return (
    <section className="aboutUs" id="about">
      <div className="aboutUs__image" />
      <div className="aboutUs__description">
        <h1 className="aboutUs__description__title">O nas</h1>
        <p className="aboutUs__description__text">
          Jesteśmy rodzinną firmą kominiarską działającą na rynku od 1996 roku. Świadczymy
          profesjonalne i terminowe usługi z zakresu kominiarstwa. Posiadamy niezbędne uprawnienia,
          profesjonalny sprzęt oraz wyszkoloną kadrę pracowniczą co pozwala nam w sposób fachowy
          wykonać zlecone usługi. Nasza wiedza i doświadczenie doceniona jest przez ogromne grono
          zadowolonych Klientów, wiernie korzystających z naszych usług od wielu lat. Odbiorcami
          naszych usług są Indywitualni Klienci oraz Wspólnoty Mieszkaniowe.
        </p>
      </div>
    </section>
  )
}

export default aboutUs
